module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('h1', [_vm._v("All Music Boxes")]), _vm._v(" "), _vm._l((_vm.musicBoxes), function(box, key) {
    return _c('div', [_c('h4', [_c('router-link', {
      attrs: {
        "to": {
          path: 'musicboxes',
          query: {
            id: box['.key']
          }
        }
      }
    }, [_vm._v(_vm._s(box.meta.title))])], 1), _vm._v(" "), _c('h6', [_vm._v(_vm._s(box.meta.creator))])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1812243f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/All.vue
// module id = 266
// module chunks = 1